// Costruttori di marker per il motore mappa. Ogni "tipo" di POI ha il suo builder,
// così è facile aggiungerne di nuovi (missioni, eventi, crediti) senza toccare il motore.
import { CATEGORY_ICONS, CATEGORY_COLORS, CATEGORY_LABELS, categoryKey } from "./categoryIcons";

const esc = (s = "") => String(s).replace(/[&<>"]/g, (c) => ({ "&": "&amp;", "<": "&lt;", ">": "&gt;", '"': "&quot;" }[c]));

const FLAME_SVG = '<svg viewBox="0 0 24 24" fill="currentColor"><path d="M12 2s5 4.5 5 10a5 5 0 0 1-10 0c0-2 1-3.5 1-3.5S6 11 6 13.5A6 6 0 0 0 18 14c0-4.5-3-9-6-12z"/></svg>';

export function businessMarkerEl(poi, onSelect, index = 0, selected = false) {
  const key = categoryKey(poi.category);
  const tier = poi.tier || "standard";
  const el = document.createElement("div");
  el.className = "poi" + (poi.has_offer ? " poi--offer" : (poi.orderable ? " poi--open" : "")) + (poi.popular ? " poi--popular" : "") + (poi.is_sponsored ? " poi--adsponsor" : (tier === "sponsor" ? " poi--sponsor" : tier === "premium" ? " poi--premium" : "")) + (selected ? " poi--active" : "");
  el.style.setProperty("--c", CATEGORY_COLORS[key]);
  el.style.animationDelay = `${(index % 24) * 45}ms`;
  el.setAttribute("data-testid", `poi-${poi.id}`);
  const tierChip = poi.is_sponsored ? `<div class="poi-tier poi-tier--ad">✦ Sponsorizzato</div>`
    : tier === "sponsor" ? `<div class="poi-tier poi-tier--sponsor">★ Sponsor</div>`
    : tier === "premium" ? `<div class="poi-tier poi-tier--premium">Premium</div>` : "";
  el.innerHTML = `
    ${poi.has_offer ? `<div class="poi-callout">✦ ${esc(poi.offer_title)}</div>` : ""}
    ${tierChip}
    <div class="poi-card">
      <div class="poi-ic">${CATEGORY_ICONS[key]}</div>
      <div class="poi-info">
        <div class="poi-name">${esc(poi.name)}${poi.popular ? `<span class="poi-fire" title="Molto richiesto">${FLAME_SVG}</span>` : ""}</div>
        <div class="poi-sub">${poi.orderable ? "Aperto" : "In arrivo"} · ${poi.prep_time || 25} min</div>
      </div>
    </div>
    <div class="poi-beam"></div><div class="poi-ring"></div>`;
  el.addEventListener("click", (e) => { e.stopPropagation(); onSelect && onSelect(poi); });
  return el;
}

export function meMarkerEl() {
  const el = document.createElement("div");
  el.className = "me-marker";
  el.innerHTML = `<div class="me-pulse"></div><div class="me-dot"></div><div class="me-label">Tu sei qui</div>`;
  return el;
}

const LOCK_SVG = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><rect x="5" y="11" width="14" height="9" rx="2"/><path d="M8 11V8a4 4 0 0 1 8 0v3"/></svg>';

// Label "comune" interattivo, leggero: nome luminoso + meta (attività / LIVE / bloccato).
// Nessun grande box: si posa sulle coordinate del comune come vera cartografia interattiva.
// "Energia Fuma": indicatore luminoso discreto sul centro del comune (nessun testo).
// Il territorio si "accende" dove Fuma è presente. I nomi geografici restano quelli nativi.
export function comuneMarkerEl(c, onSelect, compact = false, index = 0) {
  const el = document.createElement("div");
  const active = !!c.active;
  const intensity = active ? (c.intensity || 0) : 0;
  const openNow = active ? (c.openNow || 0) : 0;
  const partner = active && !!c.partner;
  const live = active ? (c.live || 0) : 0;
  el.className = "fe fe--i" + intensity
    + (active ? " fe--active" : " fe--locked")
    + ((openNow > 0 || (c.liveOrders || 0) > 0) ? " fe--pulse" : "")
    + (partner ? " fe--partner" : "")
    + (live > 0 ? " fe--live" : "");
  el.setAttribute("data-testid", `comune-${c.id}`);
  el.style.animationDelay = `${(index % 24) * 120}ms`;
  el.innerHTML = `
    <span class="fe-halo"></span>
    ${partner ? '<span class="fe-ring"></span>' : ""}
    <span class="fe-core"></span>
    ${live > 0 ? '<span class="fe-live"></span>' : ""}`;
  el.addEventListener("click", (e) => { e.stopPropagation(); onSelect && onSelect(c); });
  return el;
}

// ===== Livello 2: marker Categoria (disposte a raggiera attorno al comune) =====
export function categoryMarkerEl(item, onSelect, index = 0) {
  const key = item.key;
  const el = document.createElement("div");
  el.className = "cat";
  el.style.setProperty("--c", CATEGORY_COLORS[key] || "#00E676");
  el.style.animationDelay = `${(index % 12) * 55}ms`;
  el.setAttribute("data-testid", `cat-${key}`);
  el.innerHTML = `
    <div class="cat-badge">
      <span class="cat-ic">${CATEGORY_ICONS[key] || CATEGORY_ICONS.shop}</span>
      ${item.count ? `<span class="cat-count">${item.count}</span>` : ""}
      ${item.offer ? `<span class="cat-offer">✦</span>` : ""}
    </div>
    <div class="cat-name">${esc(item.label)}</div>
    <div class="cat-ring"></div>`;
  el.addEventListener("click", (e) => { e.stopPropagation(); onSelect && onSelect(item); });
  return el;
}

// Hub centrale del comune (non interattivo) mostrato al livello Categorie.
export function comuneHubEl(c) {
  const el = document.createElement("div");
  el.className = "hub";
  el.innerHTML = `<div class="hub-halo"></div><div class="hub-core"><span class="hub-dot"></span></div><div class="hub-name">${esc(c.name)}</div>`;
  return el;
}

// Rider live ANONIMO: puntino cyan pulsante in movimento (nessun dato personale).
export function riderMarkerEl(id = "") {
  const el = document.createElement("div");
  el.className = "rider-live";
  el.setAttribute("data-testid", id ? `rider-live-${id}` : "rider-live");
  el.innerHTML = `<div class="rider-live-pulse"></div><div class="rider-live-dot"></div>`;
  return el;
}

export const EVENT_CAT_LABELS = {
  sagra: "Sagra", festa: "Festa", concerto: "Concerto", sport: "Sport",
  mercatino: "Mercatino", inaugurazione: "Inaugurazione", culturale: "Culturale",
  promo: "Promo", altro: "Evento",
};

const EVENT_SVG = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.9" stroke-linecap="round" stroke-linejoin="round"><rect x="3" y="4.5" width="18" height="16" rx="3"/><path d="M3 9h18M8 2.5v4M16 2.5v4"/><path d="M12 12.2l0.9 1.9 2.1 0.3-1.5 1.5 0.4 2.1-1.9-1-1.9 1 0.4-2.1-1.5-1.5 2.1-0.3z"/></svg>';

// Marker EVENTO (mappa viva del territorio). Premium (sponsor/in evidenza) = oro pulsante.
export function eventMarkerEl(ev, onSelect) {
  const el = document.createElement("div");
  const premium = ev.sponsored || ev.featured;
  el.className = "event-mk" + (premium ? " event-mk--premium" : "") + (ev.is_live ? " event-mk--live" : "");
  el.setAttribute("data-testid", `event-${ev.id}`);
  el.innerHTML = `
    <div class="event-pin"><span class="event-ic">${EVENT_SVG}</span></div>
    <div class="event-label">${esc(ev.title)}</div>
    <div class="event-ring"></div>`;
  el.addEventListener("click", (e) => { e.stopPropagation(); onSelect && onSelect(ev); });
  return el;
}

// Riservato alla gamification futura (rider in tempo reale, crediti raccoglibili, missioni).
export const CATEGORY_META = { CATEGORY_LABELS, CATEGORY_COLORS };
